/** 页面访问权限。 */
export const SALES_PERFORMANCE_ACCESS = "sales_performance.report:access";
/** 导出独立权限。 */
export const SALES_PERFORMANCE_EXPORT = "sales_performance.report:export";
